// extracted by mini-css-extract-plugin
export default {"pageTitle":"client-create-page_pageTitle__HQuZh"};